import { render, staticRenderFns } from "./WtJoinButton.vue?vue&type=template&id=16b48501&scoped=true&lang=pug&"
import script from "./WtJoinButton.vue?vue&type=script&lang=js&"
export * from "./WtJoinButton.vue?vue&type=script&lang=js&"
import style0 from "./WtJoinButton.vue?vue&type=style&index=0&id=16b48501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b48501",
  null
  
)

export default component.exports